import * as React from 'react';
import { PageContext } from 'components/Context/pageContext';

const { useContext } = React;

const useTheme = () => useContext(PageContext);

export default useTheme;
